// extracted by mini-css-extract-plugin
export default {"root":"PageContainer-module_root_a2cb58"};